import React, { useState, useRef } from 'react';

const API = process.env.REACT_APP_API_URL || '';

export default function Checker({ shopifyLinks, wpLinks }) {
  const [job, setJob]                 = useState('');
  const [verdict, setVerdict]         = useState(null);
  const [proposal, setProposal]       = useState('');
  const [sender, setSender]           = useState('');
  const [loading, setLoading]         = useState(false);
  const [propLoading, setPropLoading] = useState(false);
  const [copied, setCopied]           = useState(false);
  const [propError, setPropError]     = useState('');

  const propCalledRef = useRef(false);

  async function handleCheck() {
    if (!job.trim()) return;
    propCalledRef.current = false;
    setLoading(true);
    setVerdict(null);
    setProposal('');
    setSender('');
    setPropError('');

    try {
      const res  = await fetch(`${API}/api/check`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ jobText: job })
      });
      const data = await res.json();
      setVerdict(data);

      if (data.yes && !propCalledRef.current) {
        propCalledRef.current = true;
        generateProposal(data.platform, job);
      }
    } catch {
      setVerdict({ yes: false, reason: 'Could not reach server. Is the backend running?', platform: null });
    }

    setLoading(false);
  }

  async function generateProposal(platform, jobText) {
    setPropLoading(true);
    setProposal('');
    setPropError('');

    try {
      const res  = await fetch(`${API}/api/proposal`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ jobText, platform, shopifyLinks, wpLinks })
      });
      const data = await res.json();
      if (data.error) {
        setPropError(data.error);
      } else {
        setProposal(data.proposal);
        setSender(data.sender);
      }
    } catch {
      setPropError('Could not reach the server. Make sure backend is running.');
    }

    setPropLoading(false);
  }

  function handleRegen() {
    if (!verdict || !job) return;
    generateProposal(verdict.platform, job);
  }

  function handleCopy() {
    if (!proposal) return;
    navigator.clipboard.writeText(proposal);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  function handleClear() {
    setJob('');
    setVerdict(null);
    setProposal('');
    setSender('');
    setPropError('');
    propCalledRef.current = false;
  }

  function badgeClass(platform) {
    if (platform === 'shopify')   return 'platform-badge badge-shopify';
    if (platform === 'wordpress') return 'platform-badge badge-wordpress';
    return 'platform-badge badge-web';
  }

  function badgeText(platform) {
    if (platform === 'shopify')   return 'Shopify job detected';
    if (platform === 'wordpress') return 'WordPress job detected';
    return 'Web design / development job';
  }

  return (
    <div>
      <div className="card">
        <span className="card-label">Job Description</span>
        <textarea
          rows={9}
          value={job}
          onChange={e => setJob(e.target.value)}
          placeholder="Paste the Upwork job description here..."
        />
        <div className="btn-row">
          <button className="btn-primary" onClick={handleCheck} disabled={loading || !job.trim()}>
            {loading ? <><span className="spinner" />Checking...</> : 'Check this job'}
          </button>
          <button className="btn-ghost" onClick={handleClear}>Clear</button>
        </div>
      </div>

      {verdict && (
        <div className={`verdict ${verdict.yes ? 'yes' : 'no'}`}>
          <div className="verdict-title">{verdict.yes ? 'YES, GO AHEAD' : 'NO'}</div>
          <div className="verdict-reason">{verdict.reason}</div>
          {verdict.yes && verdict.platform && (
            <span className={badgeClass(verdict.platform)}>
              {badgeText(verdict.platform)}
            </span>
          )}
        </div>
      )}

      {verdict && verdict.yes && (
        <div className="card">
          <div className="proposal-header">
            <span className="card-label" style={{ margin: 0 }}>Proposal</span>
            <div className="proposal-actions">
              <button className="btn-small" onClick={handleCopy} disabled={!proposal || propLoading}>
                {copied ? 'Copied!' : 'Copy'}
              </button>
              <button className="btn-small" onClick={handleRegen} disabled={propLoading}>
                Regenerate
              </button>
            </div>
          </div>

          <div className="proposal-body">
            {propLoading ? (
              <><span className="spinner" />Generating proposal...</>
            ) : propError ? (
              <span style={{ color: '#A32D2D' }}>{propError}</span>
            ) : (
              proposal
            )}
          </div>

          {sender && !propLoading && !propError && (
            <div className="proposal-status">
              Signing as: {sender} &nbsp;·&nbsp; Platform: {verdict.platform}
            </div>
          )}
        </div>
      )}
    </div>
  );
}